import { User, UserFilter, UserFormData, UserResponse, UserUpdate, ApiResponse } from '../types/users';
import adminApi from '../apis/admin';


// Lấy danh sách người dùng
const getUsers = async (filter: UserFilter = {}): Promise<UserResponse> => {
    const response = await adminApi.getUser(filter) as ApiResponse<User[]>;

    if (response.status === 'success') {
        return {    
            data: response.data,
        };
    } else {
        return {
            data: [],
        }
    }
};

// Lấy chi tiết người dùng
const getUserById = async (id: string): Promise<User> => {
    const response = await adminApi.getUserById(id) as ApiResponse<User>;

    if (response.status === 'success') {
        return response.data;
    } else {
        throw new Error('Get user by id failed');
    }
};

// Tạo người dùng mới
const createUser = async (data: UserFormData): Promise<User> => {
    const response = await adminApi.createUser(data) as ApiResponse<User>;

    if (response.status === 'success') {
        return response.data;
    } else {
        throw new Error('Create user failed');
    }
};

// Cập nhật người dùng
const updateUser = async (data: UserUpdate): Promise<User> => {
    const response = await adminApi.updateUser(data) as ApiResponse<User>;

    if (response.status === 'success') {
        return response.data;
    } else {
        throw new Error('Update user failed');
    }
};

// Xóa người dùng
const deleteUser = async (id: string): Promise<User> => {
    const response = await adminApi.deleteUser(id) as ApiResponse<User>;

    if (response.status === 'success') {
        return response.data;
    } else {
        throw new Error('Delete user failed');
    }
};

const userService = {
    getUsers,
    getUserById,
    createUser,
    updateUser,
    deleteUser,
};

export default userService; 